import { getTeamRequest, getTeamByIdRequest } from "../repositories/team_repository";
export const TeamService = () => {
    const fetchTeam = async (setTeamData) => {
        try {
            const response = await getTeamRequest();
            if (response?.success) {
                setTeamData(response.data);
            }
        } catch (error) {
            console.error("Failed to fetch team data.")
        }
    };

    const fetchTeamById = async (id) => {
        try {
            const response = await getTeamByIdRequest(id);
            if (response?.success) {
                return response.data;
            } else {
                console.error("Failed to fetch team details : ", response?.errors);
                throw new Error(response?.errors || "Failed to fetch team details.");
            }
        } catch (error) {
            console.error("Error in fetchTeamById : ", error);
            throw error;
        }
    }
    return {
        fetchTeam,
        fetchTeamById,
    };
};